import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../helpers/axiosInstance";

interface highlightsState {
  imageList: [];
}

const initialState: highlightsState = {
  imageList: [],
};

const highlightsSlice = createSlice({
  name: "highlights",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchHighlightsImageList.fulfilled, (state, action) => {
      state.imageList = action.payload;
    });
  },
});

export default highlightsSlice.reducer;

export const fetchHighlightsImageList = createAsyncThunk(
  "feedbackImages/getAllFeedbackHighlights",
  async () => {
    const response = await axiosInstance.get(
      "api/feedbackImages/getAllHighlights"
    );
    const result = response.data.feedbackImages.concat(
      response.data.highlightsImages
    );
    const imageList = result.filter((item: any) => item.deleted === false);
    return imageList;
  }
);

export const editHighlightsImageList = createAsyncThunk(
  "feedbackImages/editAllFeedbackHighlights",
  async (data: any) => {
    const response = await axiosInstance.put(
      "api/feedbackImages/admin/updateHighlightImage",
      data
    );
    return response.data;
  }
);

export const deleteHighlightsImage = createAsyncThunk(
  "feedbackImages/deleteHighlightsImage",
  async (id: any) => {
    const response = await axiosInstance.delete(
      `api/feedbackImages/admin/deleteHighlightImage/${id}`
    );
    return response.data;
  }
);
